import compact from 'lodash/compact';
import store from '@/store';

export default (to, routes) => {
	const { accessRight } = routes[to.params.id]?.options || {};
	if (!accessRight) {
		return;
	}
	const account = store.state.login;
	if (
		!compact(
			Object.keys(accessRight).map(key =>
				key === 'adminLevel'
					? accessRight[key] >= account[key]
					: accessRight[key].includes(account[key])
			)
		).length
	) {
		alert('권한이 없습니다');
		window.location.href = store.state.env.adminDomain;
	}
};
